<template>
  <div class="plan-upgrade-calc">
    <div class="plan-upgrade-calc__title">
      {{ $t('title') }}
      «{{ plan.title }}»:
    </div>
    <div class="d-sm-flex">
      <div class="plan-upgrade-calc__wrap plan-upgrade-calc__wrap_open">
        <div class="plan-upgrade-calc__bkt-wrap">
          <div class="plan-upgrade-calc__bkt" v-if="period.discountPercent">
            (
          </div>
          <div class="plan-upgrade-calc__bkt-wrap">
            <div>
              <div class="plan-upgrade-calc__value">
                {{ nextPriceFormatted }}
              </div>
              <div class="plan-upgrade-calc__caption">
                {{ $t('nextPrice') }}
              </div>
            </div>
            <div class="plan-upgrade-calc__mark">
              x
            </div>
            <div>
              <div class="plan-upgrade-calc__value">
                {{ period.duration }}
              </div>
              <div class="plan-upgrade-calc__caption">
                {{ $t('periodDuration') }}
              </div>
            </div>
          </div>
          <div class="plan-upgrade-calc__mark plan-upgrade-calc__mark_no-bkt">
            -
          </div>
          <div>
            <div class="plan-upgrade-calc__value">
              {{ currentPriceFormatted }}
            </div>
            <div class="plan-upgrade-calc__caption">
              {{ $t('currentPrice') }}
            </div>
          </div>
          <div class="plan-upgrade-calc__mark">
            x
          </div>
          <div class="plan-upgrade-calc__bkt-wrap">
            <div class="plan-upgrade-calc__bkt-wrap">
              <div class="plan-upgrade-calc__bkt" v-if="remainingMonths || remainingDaysInPeriod">
                (
              </div>
              <div v-if="remainingMonths">
                <div class="plan-upgrade-calc__value">
                  {{ remainingMonths }}
                </div>
                <div class="plan-upgrade-calc__caption">
                  {{ $t('remainingMonths') }}
                </div>
              </div>
              <div class="plan-upgrade-calc__mark" v-if="remainingMonths">
                +
              </div>
              <div v-if="remainingDaysInPeriod">
                <div class="plan-upgrade-calc__value">
                  {{ remainingDaysInPeriod }}
                </div>
                <div class="plan-upgrade-calc__caption">
                  {{ $t('remainingDaysInPeriod') }}
                </div>
              </div>
              <div v-if="remainingDaysInPeriod" class="plan-upgrade-calc__mark">
                /
              </div>
              <div v-if="remainingDaysInPeriod">
                <div class="plan-upgrade-calc__value">
                  {{ daysInPeriod }}
                </div>
                <div class="plan-upgrade-calc__caption">
                  {{ $t('daysInPeriod') }}
                </div>
              </div>
              <div class="plan-upgrade-calc__bkt" v-if="remainingMonths || remainingDaysInPeriod">
                )
              </div>
            </div>
          </div>
          <div class="plan-upgrade-calc__bkt" v-if="period.discountPercent">
            )
          </div>
        </div>
        <div
          class="plan-upgrade-calc__mark plan-upgrade-calc__mark_no-bkt"
          v-if="period.discountPercent"
        >
          x
        </div>
        <div v-if="period.discountPercent">
          <div class="plan-upgrade-calc__value">
            {{ (100 - period.discountPercent) / 100 }}
          </div>
          <div class="plan-upgrade-calc__caption">
            {{ $t('discount', { discount: period.discountPercent }) }}
          </div>
        </div>
        <div class="plan-upgrade-calc__mark plan-upgrade-calc__mark_no-bkt">
          =
        </div>
      </div>
      <div class="plan-upgrade-calc__price-wrap">
        <div class="plan-upgrade-calc__value">
          {{ priceFormatted }}
        </div>
        <div class="plan-upgrade-calc__caption">
          <!--          TODO показывать на xs только при развернутой формуле-->
          {{ $t('price') }}
        </div>
      </div>
    </div>
    <button class="plan-upgrade-calc__f-btn">
      {{ $t('showFormula') }}
    </button>
    <button class="plan-upgrade-calc__f-btn">
      {{ $t('collapseFormula') }}
    </button>
  </div>
</template>

<script>
import useNumberFormatter from '@/compositions/useNumberFormatter';
import { toRefs } from '@vue/composition-api';
import useAccount from '@/compositions/accounting/useAccount';

export default {
  name: 'UpgradePaymentCalculating',
  components: {},
  props: {
    calculating: {
      type: Object,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { formatCurrencyFromMoney } = useNumberFormatter();
    const { period } = useAccount();
    const { calculating, price } = toRefs(props);
    const calc = calculating.value;

    const { nextPrice, currentPrice, daysInPeriod, remainingDaysInPeriod, remainingMonths } = calc;
    const nextPriceFormatted = formatCurrencyFromMoney(nextPrice);
    const currentPriceFormatted = formatCurrencyFromMoney(currentPrice);
    const priceFormatted = formatCurrencyFromMoney(price.value);

    return {
      formatCurrencyFromMoney,
      nextPriceFormatted,
      currentPriceFormatted,
      priceFormatted,
      daysInPeriod,
      remainingDaysInPeriod,
      remainingMonths,
      period,
    };
  },
};
</script>

<style lang="scss" scoped>
.plan-upgrade-calc {
  max-width: min-content;
  padding: 1.25rem 1.75rem 1.0625rem 1.25rem;
  background: #eeeeee;
  border-radius: 0.5rem;
  font-size: 1.5rem;
  line-height: 1.1;
  color: #091a35;
  @media screen and (max-width: 1704px) {
    width: 100%;
    max-width: none;
  }
  &__title {
    min-height: 2.5rem;
    line-height: 1.3;
    margin-bottom: 0.625rem;
  }
  &__wrap {
    display: flex;
    -webkit-transition: max-height 0.5s, padding 0.5s;
    transition: max-height 0.5s, padding 0.5s;
    overflow: hidden;
  }
  &__bkt-wrap {
    display: flex;
  }
  &__item {
    margin: 0 1.875rem 1rem 0;
    &:last-child {
      margin-right: 0;
    }
  }
  &__value {
    display: inline-block;
    background: #ffffff;
    border-radius: 0.5rem;
    padding: 0.625rem 0.875rem;
    margin-bottom: 0.375rem;
  }
  &__caption {
    max-width: 4rem;
    font-size: 0.75rem;
    line-height: 1.25;
    color: rgb(9 26 53 / 50%);
  }
  &__bkt {
    padding-top: 0.625rem;
  }
  &__mark {
    display: flex;
    padding: 0 0.625rem;
    height: 2.875rem;
    align-items: center;
  }
  &__f-btn {
    display: none;
    width: 100%;
    padding: 1rem 0.5rem 0.375rem 0.5rem;
    font-size: 0.8175rem;
    line-height: 1.4;
    color: #0a82d9;
  }
}

@media screen and (max-width: 1300px) {
  .plan-upgrade-calc {
    max-width: 100%;
    padding: 1.25rem 1.25rem 1.0625rem;
    margin-right: 0;
    margin-bottom: 0.875rem;
    font-size: 1.375rem;
    &__item {
      margin: 0 1.75rem 1rem 0;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .plan-upgrade-calc {
    padding: 1.125rem 1rem 1.0625rem 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.125rem;
    &__title {
      min-height: inherit;
      font-size: 0.875rem;
      margin-bottom: 1rem;
    }
    &__wrap {
      flex-wrap: wrap;
      justify-content: center;
    }
    &__item {
      margin: 0 1.375rem 0.625rem 0;
      &:last-child {
        margin-right: 0;
      }
    }
    &__value {
      padding: 0.5rem 0.625rem;
      line-height: 1.15;
      margin-bottom: 0.25rem;
    }
    &__caption {
      max-width: 3.5rem;
      font-size: 0.6875rem;
      line-height: 1.1;
    }
    &__mark {
      padding: 0 0.375rem;
      height: 2.375rem;
    }
  }
}
@media screen and (max-width: 752px) {
  .plan-upgrade-calc {
    padding: 0.9375rem 0.625rem 0.875rem;
    margin-bottom: 0.625rem;
    &__title {
      min-height: inherit;
      font-size: 0.8175rem;
      padding: 0 0.625rem;
      margin-bottom: 0.6875rem;
    }
    &__wrap {
      max-height: 0;
      &_open {
        max-height: inherit;
      }
    }
    &__bkt-wrap {
      width: min-content;
      justify-content: center;
    }
    &__mark_no-bkt {
      width: 100%;
      justify-content: center;
    }
    &__price-wrap {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
    }
    &__f-btn {
      display: block;
    }
  }
}
</style>

<i18n lang="yml" locale="ru">
  title: Расчёт доплаты для перехода на новый тариф
  nextPrice: Стоимость нового тарифа в месяц
  currentPrice: Стоимость текущего тарифа в месяц
  remainingDaysInPeriod: Осталось дней в периоде
  remainingMonths: Осталось оплаченых месяцев
  daysInPeriod: Всего дней в периоде
  discount: 'Скидка {discount}%'
  price: Сумма к оплате
  showFormula: Показать формулу
  collapseFormula: Свернуть формулу
  periodDuration: Длительность периода в месяцах
</i18n>
<i18n lang="yml" locale="en">
  title: Calculation of additional costs for
  nextPrice: Cost of new plan per month
  currentPrice: Cost of current plan per month
  remainingDaysInPeriod: Days remaining in current period
  remainingMonths: Prepaid months
  daysInPeriod: Total days in the period
  discount: '{discount}% discount'
  price: Total
  showFormula: Show formula
  collapseFormula: Collapse formula
  periodDuration: Period duration in months
</i18n>
